import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PendingException } from 'src/common/types';

export interface ExceptionsListState {
  exceptionMarkedToRemove: PendingException | undefined;
}
const initialState: ExceptionsListState = {
  exceptionMarkedToRemove: undefined,
};

export const reducerSlice = createSlice({
  name: 'exceptionsListReducer',
  initialState,
  reducers: {
    setExceptionMarkedToRemove: (state, action: PayloadAction<PendingException>): void => {
      state.exceptionMarkedToRemove = action.payload;
    },
    resetExceptionMarkedToRemove: (state): void => {
      state.exceptionMarkedToRemove = undefined;
    },
  },
});

export const { setExceptionMarkedToRemove, resetExceptionMarkedToRemove } = reducerSlice.actions;

export const exceptionsListReducer = reducerSlice.reducer;
